import { Pill } from '@/shared/components';
import type { AriPushHistoryItem } from '@/shared/api';
import { formatMoney } from '@/shared/lib/format';

/**
 * Die übertragenen Werte einer Zeile — jede Pille trägt ihr Wort, nie nur eine Farbe (§11). Auch
 * ein aufgehobener Stopp ist eine Übertragung und steht deshalb als eigene Pille da.
 */
export function PushHistoryValuePills({
  item,
  currency,
}: {
  item: AriPushHistoryItem;
  currency: string;
}) {
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {item.rate != null && (
        <Pill size="sm" variant="numeric">
          {formatMoney(item.rate, currency)} / Nacht
        </Pill>
      )}
      {item.minStay != null && (
        <Pill size="sm" variant="default">
          Mindestens {item.minStay} Nächte
        </Pill>
      )}
      {item.maxStay != null && (
        <Pill size="sm" variant="default">
          Höchstens {item.maxStay} Nächte
        </Pill>
      )}
      {item.stopSell != null && (
        <Pill size="sm" variant={item.stopSell ? 'stop' : 'live'}>
          {item.stopSell ? 'Verkaufsstopp' : 'Verkaufsstopp aufgehoben'}
        </Pill>
      )}
      {item.closedToArrival != null && (
        <Pill size="sm" variant={item.closedToArrival ? 'warning' : 'default'}>
          {item.closedToArrival ? 'Keine Anreise' : 'Anreise wieder möglich'}
        </Pill>
      )}
      {item.closedToDeparture != null && (
        <Pill size="sm" variant={item.closedToDeparture ? 'warning' : 'default'}>
          {item.closedToDeparture ? 'Keine Abreise' : 'Abreise wieder möglich'}
        </Pill>
      )}
      {item.available != null && (
        <Pill size="sm" variant={item.available ? 'live' : 'stop'}>
          {item.available ? 'Verfügbar' : 'Blockiert'}
        </Pill>
      )}
    </div>
  );
}
